import React from 'react'

import Field from 'components/layout/form/Field'
import TextareaField from 'components/layout/form/fields/TextareaField'


const StuctureAndInterior = () => (
  <div className="entry-group">
    <h1
      className="entry-title"
      id="external-layouts"
    >
      {'Structure et second-œuvre'}
    </h1>
    <Field name='structureAndInteriorGeneralState' />
    <Field name='structureAndInteriorWaterSensitiveMaterialsPresent' />
    <div className="entry-subtitle">
      <div>
        {'Commentaires'}
      </div>
    </div>
    <TextareaField
      label="Observations : "
      name="structureAndInteriorComment"
    />
    <TextareaField
      label="Préconisations : "
      name="structureAndInteriorRecommendation"
    />
  </div>
)

export default StuctureAndInterior
